import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-page',
  template: `<ng-content></ng-content>`,
  styleUrls: ['./page.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PageComponent {}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/page/page/page.component.ts